import { TableColumn } from "../table/TableColumn";

const DeviceParameterColumns : TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "deviceParameter.deviceParamType.dptName",
        sortDirection: "asc",
        active: true,
        translationKey: "name"
    }
];

export default DeviceParameterColumns;
